import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ie11media } from 'utils/ie11'
import ReactPlaceholder from 'react-placeholder/lib'
import { TextRow } from 'react-placeholder/lib/placeholders'
import { TextHeadline3, TextCaption2 } from 'blocket-ui'
import { PlaceholderWrapper } from 'utils/LoadingAnimationStyles'
import ButtonGroupCollection from '../FilterView/FilterComponent/Collection/ButtonGroupCollection'
import ListResultCountLabel from './ListResultCountLabel'
import SortOptionsDropdown from '../../../components/SortOptionsDropdown'
import CreateAdWatch from './CreateAdWatch'

const Wrapper = styled.div`
  display: grid;
  background-color: #f9f7f6;
  grid-template-columns: auto 182px;
  grid-template-areas:
    'one one'
    'two two';
  grid-row-gap: 8px;
  ${ie11media} {
    margin-top: 8px;
  }
`

const TopRow = styled.div`
  grid-area: one;
  display: flex;
  justify-content: space-between;
`

const BottomRow = styled.div`
  grid-area: two;
  display: flex;
  justify-content: space-between;
`

const SearchResultDescription = styled(TextHeadline3)`
  display: inline;
`

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
`

const saveButtonStyles = { width: '25%', marginTop: 0, height: '32px' }
const textStyles = { marginTop: 0 }

const Placeholder = ({ device }) => (
  <div className="show-loading-animation">
    <Wrapper>
      <TextRow
        color="#e1e1e1"
        style={{ width: '35%', height: device.is('large') ? '32px' : '48px', marginTop: 0 }}
      />
      <TextRow color="#e1e1e1" style={textStyles} />
      <TextRow color="#e1e1e1" style={saveButtonStyles} />
      <TextRow color="#e1e1e1" style={textStyles} />
    </Wrapper>
  </div>
)

Placeholder.propTypes = {
  device: PropTypes.object.isRequired,
}

const MediumLayout = ({
  searchResultDescription,
  searchTotal,
  sellerTypeParameter,
  currentQuery,
  sortOrderParameter,
  handleChange,
  loading,
  device,
}) => (
  <PlaceholderWrapper>
    <ReactPlaceholder ready={!loading} customPlaceholder={<Placeholder device={device} />}>
      <Wrapper>
        <TopRow>
          <div>
            <SearchResultDescription tagName="h1">
              {searchResultDescription}
            </SearchResultDescription>{' '}
            &nbsp;
            <ListResultCountLabel results={searchTotal} />
          </div>
          <CreateAdWatch />
        </TopRow>
        <BottomRow>
          <TextCaption2>
            {sellerTypeParameter && (
              <ButtonGroupCollection
                {...sellerTypeParameter}
                onChange={handleChange}
                currentQuery={currentQuery}
              />
            )}
          </TextCaption2>
          {sortOrderParameter && (
            <DropDownWrapper>
              <SortOptionsDropdown
                {...sortOrderParameter}
                currentQuery={currentQuery}
                onChange={handleChange}
              />
            </DropDownWrapper>
          )}
        </BottomRow>
      </Wrapper>
    </ReactPlaceholder>
  </PlaceholderWrapper>
)

MediumLayout.propTypes = {
  searchResultDescription: PropTypes.node,
  searchTotal: PropTypes.number.isRequired,
  currentQuery: PropTypes.object.isRequired,
  sellerTypeParameter: PropTypes.object,
  sortOrderParameter: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  device: PropTypes.object.isRequired,
}

export default MediumLayout
